var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Move element left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-back",
    "data-name": "Icon ionic-md-arrow-round-back",
    d: "M78.691,38.618H30.041L48.91,19.482a8.325,8.325,0,0,0,0-10.893,6.466,6.466,0,0,0-9.821,0L7.671,40.883a7.576,7.576,0,0,0-2.046,5.4v.1a7.576,7.576,0,0,0,2.046,5.4l31.4,32.294a6.466,6.466,0,0,0,9.821,0,8.325,8.325,0,0,0,0-10.893L30.018,54.042h48.65c3.842,0,6.957-3.446,6.957-7.712C85.648,41.992,82.533,38.618,78.691,38.618Z",
    transform: "translate(-5.625 -6.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRound);
export default __webpack_public_path__ + "static/media/arrowLeftRound.a60b48cd8f751e3b89a6f7e9290b8cd5.svg";
export { ForwardRef as ReactComponent };